var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.08643 20.9999L11.7927 25.7074C11.8855 25.8004 11.9958 25.8742 12.1172 25.9245C12.2386 25.9748 12.3688 26.0007 12.5002 26.0007C12.6316 26.0007 12.7617 25.9748 12.8831 25.9245C13.0045 25.8742 13.1148 25.8004 13.2077 25.7074L28.2077 10.7074C28.3007 10.6146 28.3744 10.5043 28.4247 10.3829C28.4751 10.2615 28.501 10.1313 28.501 9.99993C28.501 9.86852 28.4751 9.73839 28.4247 9.61699C28.3744 9.49559 28.3007 9.3853 28.2077 9.29243L23.5002 4.58618L7.08643 20.9999Z",
    fill: "#B8772A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18V24",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5002 4.58618L7.08643 20.9999",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57368 20.5738C1.53893 20.6088 1.51528 20.6532 1.50572 20.7016C1.49616 20.7499 1.50111 20.8 1.51995 20.8456C1.53878 20.8911 1.57066 20.9301 1.61158 20.9576C1.6525 20.9851 1.70063 20.9998 1.74993 21.0001H7.08618L11.7924 25.7076C11.8853 25.8005 11.9956 25.8743 12.117 25.9246C12.2384 25.9749 12.3685 26.0008 12.4999 26.0008C12.6313 26.0008 12.7615 25.9749 12.8829 25.9246C13.0043 25.8743 13.1146 25.8005 13.2074 25.7076L28.2074 10.7076C28.3004 10.6147 28.3742 10.5044 28.4245 10.383C28.4748 10.2616 28.5007 10.1315 28.5007 10.0001C28.5007 9.86864 28.4748 9.73851 28.4245 9.61711C28.3742 9.49572 28.3004 9.38543 28.2074 9.29255L21.2074 2.29255C21.1146 2.19958 21.0043 2.12582 20.8829 2.07549C20.7615 2.02517 20.6313 1.99927 20.4999 1.99927C20.3685 1.99927 20.2384 2.02517 20.117 2.07549C19.9956 2.12582 19.8853 2.19958 19.7924 2.29255L1.57368 20.5738Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2075 17.7075L24.2075 20.7075C24.3949 20.8947 24.6489 20.9999 24.9138 21H31.5",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCamera);
export default __webpack_public_path__ + "static/media/SecurityCamera.f0576b7e255ed70d397e7797b3b8d4c6.svg";
export { ForwardRef as ReactComponent };